// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login-page {
  background-color: white;
}

.padding-top {
  padding-top: 100px;
}

.resized-img {
  max-width: 100%;
}

.horizontal-align {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.vertical-align {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  /* Column | row */
}

/* NIAS LOGIN BUTTON */
.login-button-wrapper {
  margin-left: auto;
  margin-right: auto;
}

a.go_register {
  display: block;
  font-family: "Roboto";
  font-size: 0.875em; /* 14px */
  font-weight: 500;
  line-height: 42px;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  background-color: #ca1720;
  padding-right: 20px;
  border-radius: 21px;
  display: flex;
  align-items: center;
  width: 124px;
}

a.go_register:hover {
  color: #fff;
  background-color: #2cad56;
}

a.go_register img {
  flex: 0;
  display: block;
  margin: 0 10px 0 6px;
}

.login-user-manuals {
  position: fixed;
  left: 45px;
  bottom: 75px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/nias-change-subject/nias-change-subject.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AAEF;;AACA,sBAAA;AAEA;EACE,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;EACA,kBAAA,EAAA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AACF;;AACA;EACE,WAAA;EACA,yBAAA;AAEF;;AAAA;EACE,OAAA;EACA,cAAA;EACA,oBAAA;AAGF;;AAAA;EACE,eAAA;EACA,UAAA;EACA,YAAA;AAGF","sourcesContent":["#login-page {\n  background-color: white;\n}\n.padding-top {\n  padding-top: 100px;\n}\n\n.resized-img {\n  max-width: 100%;\n}\n\n.horizontal-align {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n\n.vertical-align {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n  /* Column | row */\n}\n\n/* NIAS LOGIN BUTTON */\n\n.login-button-wrapper {\n  margin-left: auto;\n  margin-right: auto;\n}\n\na.go_register {\n  display: block;\n  font-family: 'Roboto';\n  font-size: 0.875em; /* 14px */\n  font-weight: 500;\n  line-height: 42px;\n  color: #fff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-color: #ca1720;\n  padding-right: 20px;\n  border-radius: 21px;\n  display: flex;\n  align-items: center;\n  width: 124px;\n}\na.go_register:hover {\n  color: #fff;\n  background-color: #2cad56;\n}\na.go_register img {\n  flex: 0;\n  display: block;\n  margin: 0 10px 0 6px;\n}\n\n.login-user-manuals {\n  position: fixed;\n  left: 45px;\n  bottom: 75px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
